import React from "react";
import { HandHelping, Lightbulb } from "lucide-react";
import Dots from "./Dots";

const FeaturesAndBenefits = () => {
  return (
    <>
      <div className="flex flex-col items-center w-full">
        <h1 className="text-3xl font-bold text-center text-customText-900">
          Features
          <div className="top-0 w-full h-1 mt-0.5 rounded-full bg-customGreen-500" />
        </h1>
      </div>
      <div className="grid grid-cols-3 gap-x-10 gap-y-16">
        <div className="space-y-4">
          <div className="flex items-center gap-2 text-customGreen-700">
            <Lightbulb className="size-7" />
            <span className="text-xl font-bold">Billing and Tax Inquiries</span>
          </div>
          <p className="text-sm text-customText-800">
            Helps inquiries regarding bills, available payment methods, and
            deadlines as well as advice on tax-related issues, such as
            deductions, credits, and submission deadlines.
          </p>
        </div>
        <div className="space-y-4">
          <div className="flex items-center gap-2 text-customGreen-700">
            <Lightbulb className="size-7" />
            <span className="text-xl font-bold">
              Natural Language Processing
            </span>
          </div>
          <p className="text-sm text-customText-800">
            Ask questions in everyday language and receive accurate responses.
          </p>
        </div>
        <div className="space-y-4">
          <div className="flex items-center gap-2 text-customGreen-700">
            <Lightbulb className="size-7" />
            <span className="text-xl font-bold">
              Personalized Recommendation
            </span>
          </div>
          <p className="text-sm text-customText-800">
            Provides personalized recommendations based on the unique profiles
            and financial circumstances of each member.
          </p>
        </div>
        <div className="space-y-4">
          <div className="flex items-center gap-2 text-customGreen-700">
            <Lightbulb className="size-7" />
            <span className="text-xl font-bold">
              Financial Planning Support
            </span>
          </div>
          <p className="text-sm text-customText-800">
            Provides support for budgeting, loan projections, and various
            financial planning resources.
          </p>
        </div>
        <div className="space-y-4">
          <div className="flex items-center gap-2 text-customGreen-700">
            <Lightbulb className="size-7" />
            <span className="text-xl font-bold">Multi-channel Access</span>
          </div>
          <p className="text-sm text-customText-800">
            Available via web, mobile apps, or social media platforms for
            convenience.
          </p>
        </div>
        <div className="space-y-4">
          <div className="flex items-center gap-2 text-customGreen-700">
            <Lightbulb className="size-7" />
            <span className="text-xl font-bold">Alerts and Notifications</span>
          </div>
          <p className="text-sm text-customText-800">
            Sends reminders for payment deadlines, upcoming meetings, and
            important regulatory updates.
          </p>
        </div>
      </div>
      {/* Benefits */}
      <div className="flex flex-col gap-5 px-40 pb-20 pt-52">
        <div className="flex flex-col items-center w-full mb-8">
          <h1 className="text-3xl font-bold text-center text-customText-900">
            Benefits
            <div className="top-0 w-full h-1 mt-0.5 rounded-full bg-customGreen-500" />
          </h1>
        </div>
        <div className="relative flex items-center gap-8">
          <div className="z-10 p-4 rounded-full h-fit w-fit bg-customGreen-700">
            <HandHelping className="size-8 text-customText-100" />
          </div>
          <Dots classname="absolute top-0 left-0 -rotate-90 -translate-x-6 -translate-y-6" />
          <div className="flex flex-col gap-1">
            <span className="font-bold text-customText-900">Efficiency</span>
            <p className="text-sm text-customText-800">
              Simplify repetitive tasks and spend less time on routine
              inquiries, allowing you to focus on more complex issues.
            </p>
          </div>
        </div>
        <div className="w-full h-0.5 rounded-full bg-customSlate-600" />
        <div className="flex items-center gap-8">
          <div className="p-4 rounded-full h-fit w-fit bg-customGreen-700">
            <HandHelping className="size-8 text-customText-100" />
          </div>
          <div className="flex flex-col gap-1">
            <span className="font-bold text-customText-900">
              24/7 Availablity
            </span>
            <p className="text-sm text-customText-800">
              Access BETH AI anytime to respond to inquiries and help you beyond
              standard business hours.
            </p>
          </div>
        </div>
        <div className="w-full h-0.5 rounded-full bg-customSlate-600" />
        <div className="flex items-center gap-8">
          <div className="p-4 rounded-full h-fit w-fit bg-customGreen-700">
            <HandHelping className="size-8 text-customText-100" />
          </div>
          <div className="flex flex-col gap-1">
            <span className="font-bold text-customText-900">Cost Savings</span>
            <p className="text-sm text-customText-800">
              Reduce operational costs by automating tasks.
            </p>
          </div>
        </div>
        <div className="w-full h-0.5 rounded-full bg-customSlate-600" />
        <div className="flex items-center gap-8">
          <div className="p-4 rounded-full h-fit w-fit bg-customGreen-700">
            <HandHelping className="size-8 text-customText-100" />
          </div>
          <div className="flex flex-col gap-1">
            <span className="font-bold text-customText-900">
              Accurate Information
            </span>
            <p className="text-sm text-customText-800">
              Get reliable and precise financial details in a snap, lowering the
              chances of miscommunication errors.
            </p>
          </div>
        </div>
        <div className="w-full h-0.5 rounded-full bg-customSlate-600" />
        <div className="relative flex items-center gap-8">
          <div className="z-10 p-4 rounded-full h-fit w-fit bg-customGreen-700">
            <HandHelping className="size-8 text-customText-100" />
          </div>
          <Dots classname="absolute bottom-0 left-0 -rotate-180 -translate-x-6 translate-y-6" />
          <div className="flex flex-col gap-1">
            <span className="font-bold text-customText-900">
              Personalization
            </span>
            <p className="text-sm text-customText-800">
              Receive customized guidance according to your unique circumstances
              for a smooth user experience.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeaturesAndBenefits;
